var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 39,
    fill: "#016938"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7102 25.6828C57.7102 25.6828 53.7802 23.9627 51.9604 25.9828C50.1509 27.9924 33.93 46.9828 33.93 46.9828C33.93 46.9828 27.77 40.3331 25.7498 38.5229C23.7298 36.7135 20 38.8229 20 38.8229L33.9696 53.7231L57.7107 25.6838L57.7102 25.6828Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/greenTick.fef1f25821279b6c50893522830f8b98.svg";
export { ForwardRef as ReactComponent };